import React from 'react';

/**
 * Instrument metrics panel — shared structure for IASH and IPRA data boxes.
 *
 * Props:
 *   title   {string}           – instrument acronym (IASH / IPRA)
 *   caption {string}           – full instrument name
 *   metrics {Array<{label, value}>}
 */
const ManCrossInstrumentPanel = ({ title, caption, metrics }) => (
    <div className="mgcr-panel">
        <div className="mgcr-instrument-title">{title}</div>
        <div className="mgcr-instrument-caption">{caption}</div>
        <div className="mgcr-metric-list">
            {metrics.map(({ label, value }) => (
                <div key={label} className="mgcr-metric-row">
                    <span className="mgcr-metric-label">{label}</span>
                    <span className="mgcr-metric-value">{value}</span>
                </div>
            ))}
        </div>
    </div>
);

export default ManCrossInstrumentPanel;
